module.exports = __webpack_public_path__ + "static/img/nav_userinfo.b3b6192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_userinfo.svg
// module id = T0Xj
// module chunks = 1